import { T } from '@angular/cdk/keycodes';
import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef, inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
interface IDialogHub<T> {
    key: string;
    dialogRef?: MatDialogRef<T>,
    data?: any;
}
@Injectable({
    providedIn: 'root'
})
export class DialogService {
    private dialogs: IDialogHub<any>[] = [];
    constructor(public _dialog: MatDialog) { }

    openDialog<T>(name: string, component: ComponentType<T> | TemplateRef<T>, dialogConfig?: MatDialogConfig): MatDialogRef<T, any> {
        if (dialogConfig == undefined || dialogConfig == null) {
            dialogConfig = new MatDialogConfig();
        } else {
            dialogConfig = { ...dialogConfig };
        }
        dialogConfig.autoFocus = true;
        dialogConfig.width = '400px';
        dialogConfig.height = '200px';
        const dialogRef = this._dialog.open(component, dialogConfig);
        this.dialogs.push({ key: name, dialogRef: dialogRef });
        return dialogRef;
    }
    openDialogDisableClose<T>(name: string, component: ComponentType<T> | TemplateRef<T>, dialogConfig?: MatDialogConfig): MatDialogRef<T, any> {
        if (dialogConfig == undefined || dialogConfig == null)
            dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '400px';
        dialogConfig.height = '200px';

        const dialogRef = this._dialog.open(component, dialogConfig);
        this.dialogs.push({ key: name, dialogRef: dialogRef });
        return dialogRef;
    }
    openSmallDialog<T>(name: string, component: ComponentType<T> | TemplateRef<T>, dialogConfig?: MatDialogConfig): MatDialogRef<T, any> {
        if (dialogConfig == undefined || dialogConfig == null)
            dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '400px';
        dialogConfig.height = '200px';
        const dialogRef = this._dialog.open(component, dialogConfig);
        this.dialogs.push({ key: name, dialogRef: dialogRef });
        return dialogRef;
    }
    openMediumDialog<T>(name: string, component: ComponentType<T> | TemplateRef<T>, dialogConfig?: MatDialogConfig): MatDialogRef<T, any> {
        if (dialogConfig == undefined || dialogConfig == null)
            dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.width = '500px';
        dialogConfig.height = '500px';
        const dialogRef = this._dialog.open(component, dialogConfig);
        this.dialogs.push({ key: name, dialogRef: dialogRef });
        return dialogRef;
    }
    openLargeDialog<T>(name: string, component: ComponentType<T> | TemplateRef<T>, dialogConfig?: MatDialogConfig): MatDialogRef<T, any> {
        if (dialogConfig == undefined || dialogConfig == null)
            dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.height = '600px';
        const dialogRef = this._dialog.open(component, dialogConfig);
        this.dialogs.push({ key: name, dialogRef: dialogRef });
        return dialogRef;
    }
    closeDialog(name: string, dialogResult?: any) {
        this.dialogs.find(n => n.key === name)?.dialogRef?.close(dialogResult);
    }
    getDialogData(name: string) {
        return this.dialogs.find(n => n.key === name)?.data;
    }
    setDialogData(name: string, data: any): boolean {
        if (data == undefined || data == null) {
            console.error("data is invalid");
            return false;
        }
        this.updateDialog(name, data);
        return true;
    }
    updateDialog<T>(name: string, data: any) {
        const dialog = this.dialogs.find(n => n.key === name);
        if (dialog) {
            if (typeof (data) === typeof (MatDialogRef<T, any>))
                dialog.dialogRef = data;
            else
                dialog.data = data;
        }
        else {
            if (typeof (data) === typeof (MatDialogRef<T, any>))
                this.dialogs.push({ key: name, dialogRef: data })
            else
                this.dialogs.push({ key: name, data: data })
        }
    }
}
